import React from 'react';

import '../../assets/dsgov/css/components/button.css';
import '../../assets/dsgov/css/components/loading.css';
import './Button.css';
import { parseProps } from './@uteis';

const Button = (_props) => {
  const props = parseProps(_props);

  let classes = 'br-button ';
  if (props.classes) {
    classes += props.classes;
  }

  return (
    <button
      onClick={props.onClick}
      onBlur={props.onBlur || null}
      className={classes}
      type="button"
      {...props}
    >
      {props.children}
      {props.label}
    </button>
  );
};

export default Button;
